import { render } from "./Archive.vue?vue&type=template&id=6e839ad2"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"

import "./Archive.vue?vue&type=style&index=0&id=6e839ad2&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__